export const premiumServiceAvailableHours = {
  sunday: [
    {
      open: '',
      close: '',
      id: '5ca5578b0c5c7',
      isOpen: false,
    }
  ],
  monday: [
    {
      open: '0800',
      close: '1700',
      id: '5ca5578b0c5d1',
      isOpen: true,
      index: 1
    }
  ],
  tuesday: [
    {
      open: '0800',
      close: '1700',
      id: '5ca5578b0c5d8',
      isOpen: true,
    }
  ],
  wednesday: [
    {
      open: '0800',
      close: '1700',
      id: '5ca5578b0c5df',
      isOpen: true,
    }
  ],
  thursday: [
    {
      open: '0800',
      close: '1700',
      id: '5ca5578b0c5e6',
      isOpen: true,
    }
  ],
  friday: [
    {
      open: '0800',
      close: '1700',
      id: '5ca5578b0c5ec',
      isOpen: true
    },
    {
      open: '1900',
      close: '2200',
      id: '5ca5578b0c5f2',
      isOpen: true
    }
  ],
  saturday: [
    {
      open: '24hrs',
      close: '24hrs',
      id: '5ca5578b0c5f8',
      isOpen: true
    }
  ]
}

export const sortPremiumServiceAvailableHours = (obj: any): any => {
  const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  const sortedObj = new Map();

  daysOfWeek.forEach(day => {
    if (Object.prototype.hasOwnProperty.call(obj, day)) {
      sortedObj.set(day, obj[day]);
    }
  });

  const sortedData: any = {};
  sortedObj.forEach((value, key) => {
    sortedData[key] = value;
  });

  return sortedData;
};

export const isPremiumServiceAvailableHoursValid = (obj: any): boolean => {
  const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  for (const day of daysOfWeek) {
    if (Object.prototype.hasOwnProperty.call(obj, day)) {
      for (const timeSlot of obj[day]) {
        if (timeSlot.isOpen === true && (!timeSlot.open?.length || !timeSlot.close?.length)) {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  return true;
};